import { useAuth } from "../../context/AuthContext";

const CanAccess = ({ module, component, children }) => {
  const { rolePermission } = useAuth();

  const hasPermission = CanAccess.can(rolePermission, module, component);

  return hasPermission ? children : null;
};

CanAccess.can = (rolePermission, module, component) => {
  return rolePermission?.some(
    (item) =>
      item.module_name === module &&
      item.component_name === component &&
      item.can_access === true
  );
};

export default CanAccess;
